import { Component, inject } from '@angular/core';
import { ThirdPartyPropertyCategoryService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ThirdPartyPropertyCategoryCreateDto,
  ThirdPartyPropertyCategoryDto,
  ThirdPartyPropertyCategoryExcelDownloadDto,
  ThirdPartyPropertyCategoryUpdateDto,
} from '../proxy/planning/dtos/third-party-property-category';
import { THIRDPARTYPROPERTYCATEGORY_CONFIG, THIRDPARTYPROPERTYCATEGORY_FIELDS } from './third-party-property-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-third-property-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ThirdPartyPropertyCategoryService, ConfirmationService],
  templateUrl: './third-party-property-category.html',
  styleUrl: './third-party-property-category.scss',
})
export class ThirdPartyPropertyCategory extends BaseCrudComponent<
  ThirdPartyPropertyCategoryDto,
  ThirdPartyPropertyCategoryCreateDto,
  ThirdPartyPropertyCategoryUpdateDto,
  ThirdPartyPropertyCategoryExcelDownloadDto
> {
  service = inject(ThirdPartyPropertyCategoryService);
  config = THIRDPARTYPROPERTYCATEGORY_CONFIG;
  fields = THIRDPARTYPROPERTYCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ThirdPartyPropertyCategoryDto): ThirdPartyPropertyCategoryUpdateDto {
    return {
      description: data.description,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ThirdPartyPropertyCategory';
  }
}
